import { DragNDropFileUploader, IFileSettings } from 'legacy/lut/library/dragNDrop'
import { FC, useCallback, useState } from 'react'
import { useSelector } from 'react-redux'

import { LoaderOverlay } from 'cng-common/components/loaderOverlay'
import { selectQBREntryId } from 'partner360/features/QBR'

import { uploadQbrAttachment } from './api/uploadQbrAttachment'
import { AttachmentsTable } from './components/attachmentsTable/AttachmentsTable'
import { DndCustomView } from './components/dndCustomView/DndCustomView'
import { ALLOWED_ATTACHMENTS } from './configs'

import styles from './QbrAttachments.module.scss'

export const QbrAttachments: FC = () => {
  const [isLoading, setIsLoading] = useState(false)
  const documentId = useSelector(selectQBREntryId)

  const uploadAttachments = useCallback(
    async (filesInfo: IFileSettings[]) => {
      if (!documentId) {
        return
      }

      setIsLoading(true)
      await uploadQbrAttachment({ filesInfo, documentId })
      setIsLoading(false)
    },
    [documentId]
  )

  return (
    <div className={styles.root}>
      <LoaderOverlay isVisible={isLoading} />
      <div className={styles.dndContainer}>
        <DragNDropFileUploader
          multifiles
          fileListVisibility={false}
          rootStyleVisible={false}
          disabled={!documentId}
          acceptedFormats={ALLOWED_ATTACHMENTS}
          className={styles.dndArea}
          changeFileLoader={uploadAttachments}
          content={DndCustomView}
        />
      </div>
      <div className={styles.tableContainer}>
        <AttachmentsTable />
      </div>
    </div>
  )
}
